module.exports = __webpack_public_path__ + "media/images/application/template/cc-home-bkg-960px-ff5f9747d64e1a338fe98ba43d408244.jpg";